export default function formatNumber(number, decimal = 2) {
    if (!number) return "0.00";
    const n = parseFloat(number).toFixed(decimal);
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
